import Axios from "../helper/appConfig";

export const getAllEventList = async (date) => {
  const search = [
    {
      searchfield: "status",
      searchvalue: "active",
      criteria: "eq",
      datatype: "text",
    },
    {
      searchfield: "property.onlineavailibility",
      searchvalue: true,
      criteria: "eq",
      datatype: "boolean",
    },
  ];

  if (date) {
    search.push(
      {
        searchfield: "property.startdate",
        searchvalue: date,
        criteria: "gte",
        datatype: "Date",
        cond: "and",
      },
      {
        searchfield: "property.startdate",
        searchvalue: date,
        criteria: "lte",
        datatype: "Date",
        cond: "and",
      }
    );
  }

  const body = {
    search: search,
    sort: {
      updatedAt: -1,
    },
  };

  return Axios.post("api/events/filter", body);
};

export const getEachEventDetailService = (id) => {
  const body = {
    search: [
      {
        searchfield: "_id",
        searchvalue: id,
        criteria: "eq",
        datatype: "ObjectId",
      },
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
        datatype: "text",
      },
    ],
    viewname: "eventviews",
  };

  return Axios.post(`api/events/filter/view`, body);
};

export const billServices = (payload) => {
  return Axios.post(`api/bills`, payload);
};

export const getCouponListServices = (eventid) => {
  const body = { _id: eventid, type: "event" };

  return Axios.post(`api/coupons/checkvalidity`, body);
};

export const getDatasServices = (id) => {
  return Axios.post(`api/events/${id}`);
};

export const getLoginDetailService = (id, schemaname) => {
  // console.log("schemaname::: ", schemaname);
  // console.log("id::: ", id);
  if (!id || !schemaname) {
    throw new Error(
      "Both ID and schema name are required for getLoginDetailService."
    );
  }
  return Axios.get(id ? `api/${schemaname}/${id}/` : `api/${schemaname}`);
};
